import { ControlGroup } from './ControlGroup'
import {
  app,
  AutoPanel,
  autoPlayService,
  BetHistoryPortrait,
  calculateSize,
  defaultSize,
  CurrentTime,
  GameNameTag,
  ga4Info,
  t,
  RefNoDisplayPlugin,
  soundManager,
  SoundType,
  useAutoPlayStore,
} from '@slot-nx/core'
import { Slot } from './Slot'
import { useEffect, useState } from 'react'
import { inGame } from '../domain/inGame/inGame'
import { Container } from '@pixi/react'
import { assetManager } from '../domain/assetManager/index'
import { Background, GodziBg } from './Background'
import { gameConfig } from '../config'
import { NumberDisplay } from './NumberDisplay'
import { MultiplierReel } from './MultiplierReel'
import { TumbleWinBar } from './winning/TumbleWinBar'
import { TotalWinBar } from './winning/TotalWinBar'
import { WinningPanel } from './winning/WinningPanel'
import { BuyBonusBar } from './buyBonus/BuyBonusBar'
import { BuyBonusPopup } from './buyBonus/BuyBonusPopup'
import { BuyBonusConfirmPopup } from './buyBonus/BuyBonusConfirmPopup'
import { FreeGameScene } from './FreeGameScene'
import { FreeSpinLeft } from './FreeSpinLeft'
import { SlotDisplay } from './SlotDisplay'
import { removeBackground } from '../domain/bg'
import { useGameStore } from '../domain/game/store/GameStore'
import { onSpin } from '../domain/spin/util/spinUtil'
import { Loading } from './Loading'
import { BetDetail } from './betDetail/BetDetail'
import { PayTable } from './gameRules/PayTable'
import { ErrorPopup } from './ErrorPopup'
import { DesktopBackground } from './DesktopBackground'
import { GodziDropIcon } from './godziDrop/GodziDropIcon'
import { GodziDropWrapper } from './godziDrop/GodziDropWrapper'
import { Voucher } from './voucher/Voucher'
import { betDetailService } from '../domain/betDetail/service/BetDetailService'
import { useBetDetailStore } from '../domain/betDetail/store/betDetailStore'
import VConsole from 'vconsole'
//
export const App = () => {
  app.renderer.background.color = 0x000000

  const [scale, setScale] = useState(defaultSize.scale)
  const [position, setPosition] = useState({ x: defaultSize.x, y: defaultSize.y })
  const { isShowLoading, isLoadedAssets } = useGameStore()

  useEffect(() => {
    inGame()
    assetManager.loadEssential().then(() => {
      useGameStore.setState({ isLoadedAssets: true })
      removeBackground()
      ga4Info.recordGodziLoadingTime()
    })
    ga4Info.measureFps()
  }, [])

  useEffect(() => {
    if (import.meta.env.MODE === 'prod') return
    const _ = new VConsole()
  }, [])

  useEffect(() => {
    if (isLoadedAssets) {
      const resize = () => {
        const newSize = calculateSize()
        app.renderer.resize(window.innerWidth, window.innerHeight)
        setScale(newSize.scale)
        setPosition({
          x: newSize.x,
          y: newSize.y,
        })
      }
      resize()
      window.onresize = resize
      document.onvisibilitychange = () => {
        if (document.visibilityState === 'visible') {
          resize()
        }
      }
      window.addEventListener('orientationchange', resize)

      return () => {
        window.onresize = null
        window.removeEventListener('orientationchange', resize)
        document.onvisibilitychange = null
      }
    }
  }, [isLoadedAssets])
  return (
    <Container name="App" position={position} scale={scale}>
      <DesktopBackground />
      <Background />
      <GodziBg />
      {
        isLoadedAssets && isShowLoading && (
          <Loading />
        )
      }
      {!isShowLoading
      && (
        <>
          <TumbleWinBar />
          <TotalWinBar />
          <Slot />
          <GodziDropIcon />
          <MultiplierReel />
          <SlotDisplay />
          <BuyBonusBar />
          <NumberDisplay x={0} y={gameConfig.resolution.height - 340} />
          <ControlGroup x={0} y={gameConfig.resolution.height - 256} />
          <RefNoDisplayPlugin portraitResolution={gameConfig.resolution} />
          <CurrentTime x={gameConfig.resolution.width - 80} y={30} />
          <GameNameTag name={t('siteTitle')} x={20} y={gameConfig.resolution.height - 40} />
          <FreeSpinLeft />
          <WinningPanel />
          <BuyBonusPopup />
          <BuyBonusConfirmPopup />
          <FreeGameScene />
          <AutoPanel
            onConfirm={() => {
              soundManager.play(SoundType.spin)
              autoPlayService.startAutoPlay(() => {
                onSpin()
              })
              const autoPlayTotalTime = useAutoPlayStore.getState().current
              ga4Info.addEvent(`autoplay_${autoPlayTotalTime}`)
            }}
            borderColor="#FF74A8"
          />
          <BetHistoryPortrait
            width={gameConfig.resolution.width}
            height={gameConfig.resolution.height}
            openBetDetail={(refNo, statementDate) => {
              useBetDetailStore.setState({ isOpenBetDetail: true })
              betDetailService.getBetDetail(refNo, statementDate)
            }}
          />
          <Voucher />
          <GodziDropWrapper />
          <BetDetail />
          <PayTable />
        </>
      )}

      <ErrorPopup />
    </Container>
  )
}
